import { VStack } from '@chakra-ui/react'
import React from 'react'
import { Layout, SettingBox } from '../../components'

const Claims = () => {
  return (
    <Layout noMb title="Claims">
      <VStack flex={1} spacing={0} w="full">
        {Options.map((item, index) => (
          <SettingBox
            key={item.title}
            borderBottom={index === 1 ? '1px solid #e2e1e1' : 'none'}
            {...item}
          />
        ))}
      </VStack>
    </Layout>
  )
}

export { Claims }

const Options = [
  {
    title: 'Email',
    description: 'pretotype@trium.ng',
    icon: (
      <svg
        width="20"
        height="19"
        viewBox="0 0 20 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 0.5H19C19.2652 0.5 19.5196 0.605357 19.7071 0.792893C19.8946 0.98043 20 1.23478 20 1.5V17.5C20 17.7652 19.8946 18.0196 19.7071 18.2071C19.5196 18.3946 19.2652 18.5 19 18.5H1C0.734784 18.5 0.48043 18.3946 0.292893 18.2071C0.105357 18.0196 0 17.7652 0 17.5V1.5C0 1.23478 0.105357 0.98043 0.292893 0.792893C0.48043 0.605357 0.734784 0.5 1 0.5ZM18 4.738L10.072 11.838L2 4.716V16.5H18V4.738ZM2.511 2.5L10.061 9.162L17.502 2.5H2.511Z"
          fill="#4D80E4"
        />
      </svg>
    )
  },
  {
    title: 'Telephone',
    description: '+234-903-795-7970',
    icon: (
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.366 8.182C7.30434 9.83048 8.66952 11.1957 10.318 12.134L11.202 10.896C11.3442 10.6969 11.5543 10.5569 11.7928 10.5023C12.0313 10.4478 12.2814 10.4825 12.496 10.6C13.9103 11.3729 15.4722 11.8378 17.079 11.964C17.3298 11.9839 17.5638 12.0975 17.7345 12.2823C17.9052 12.4671 18 12.7094 18 12.961V17.423C18.0001 17.6706 17.9083 17.9094 17.7424 18.0932C17.5765 18.277 17.3483 18.3927 17.102 18.418C16.572 18.473 16.038 18.5 15.5 18.5C6.94 18.5 0 11.56 0 3C0 2.462 0.027 1.928 0.082 1.398C0.107255 1.1517 0.222984 0.923521 0.40679 0.757634C0.590595 0.591747 0.829406 0.499947 1.077 0.5H5.539C5.79056 0.499968 6.0329 0.594752 6.21768 0.765451C6.40247 0.93615 6.51613 1.17022 6.536 1.421C6.66222 3.02779 7.12708 4.58968 7.9 6.004C8.01746 6.21856 8.05221 6.46874 7.99767 6.7072C7.94312 6.94565 7.80306 7.15584 7.604 7.298L6.366 8.182ZM3.844 7.525L5.744 6.168C5.20478 5.00409 4.83535 3.76884 4.647 2.5H2.01C2.004 2.666 2.001 2.833 2.001 3C2 10.456 8.044 16.5 15.5 16.5C15.667 16.5 15.834 16.497 16 16.49V13.853C14.7312 13.6646 13.4959 13.2952 12.332 12.756L10.975 14.656C10.4287 14.4437 9.89801 14.1931 9.387 13.906L9.329 13.873C7.36758 12.7567 5.74328 11.1324 4.627 9.171L4.594 9.113C4.30691 8.60199 4.05628 8.07134 3.844 7.525Z"
          fill="#4D80E4"
        />
      </svg>
    )
  }
]
